import { Building2, Monitor, Ticket, User } from 'lucide-react';
import type { FindResult, FindType } from '@/api/insights';
import { companyPath, insightsDevicePath, insightsPersonPath, ticketPath } from '@/lib/routes';
import { cn } from '@/lib/utils';

/** Shared bits of record search: the header Find box and the /insights/find page. */

export const FIND_ICON: Record<FindType, typeof Monitor> = { device: Monitor, person: User, ticket: Ticket, company: Building2 };
export const FIND_LABEL: Record<FindType, string> = { device: 'Devices', person: 'People', ticket: 'Tickets', company: 'Companies' };
export const FIND_ORDER: FindType[] = ['ticket', 'device', 'person', 'company'];

export function findPath(r: FindResult): string {
  switch (r.type) {
    case 'device': return insightsDevicePath(r.key);
    case 'person': return insightsPersonPath(r.key);
    case 'ticket': return ticketPath(r.key);
    case 'company': return companyPath(r.key);
  }
}

/** The picked client's results first (search itself stays global), then by score. */
export function rankForScope(results: FindResult[], companyId: number | null): FindResult[] {
  if (companyId == null) return results;
  return [...results].sort((a, b) => Number(b.companyId === companyId) - Number(a.companyId === companyId) || b.score - a.score);
}

const BAD = new Set(['offline', 'disabled', 'gap', 'drift', 'inactive', 'unlicensed']);
const GOOD = new Set(['online']);

export function FindTags({ tags }: { tags: string[] }) {
  return (
    <>
      {tags.map((t) => (
        <span key={t} className={cn('rounded px-1 py-px text-[10px] font-medium',
          GOOD.has(t) ? 'bg-success-soft text-success' : BAD.has(t) ? 'bg-warning-soft text-warning' : 'bg-muted text-muted-foreground')}>{t}</span>
      ))}
    </>
  );
}
